// src/oura/components/onboarding/SnapshotDrawer.tsx
//
// The Baseline Snapshot, opened from the staff results card (Jack, 20 Oct
// 2026): a drawer on the right with the PDF Oura made, in the same PDF viewer
// the Reports drawer uses, so staff can read it without leaving Onboarding.
// Until the backend gives the PDF's address, a placeholder says where it will
// appear. Nothing here reaches the client: it goes to them only with the send.

import { FileTextIcon } from "lucide-react";
import { cn } from "../../lib/cn";
import { PDFViewer } from "@component/pdf-viewer";
import { Drawer, TYPE } from "@oura/ui";
import { dayMonth } from "../../onboarding/derive";

export function SnapshotDrawer({
    open,
    onClose,
    businessName,
    readyAt,
    url,
}: {
    open: boolean;
    onClose: () => void;
    businessName: string;
    readyAt: string | null;
    /** The snapshot PDF, when the backend gives its address. */
    url: string | null;
}) {
    return (
        <Drawer
            open={open}
            onClose={onClose}
            width={760}
            title="Baseline Snapshot"
            sub={`What AI says about ${businessName} on the 50 questions${readyAt ? `, made ${dayMonth(readyAt)}` : ""}. The client sees it only when you send it.`}
        >
            {url ? (
                <PDFViewer url={url} className="mx-auto" defaultZoom={1.1} />
            ) : (
                <div className="grid min-h-[60vh] place-items-center rounded-2xl border border-dashed border-gray-200 bg-gray-50 p-8 text-center">
                    <div className="max-w-sm">
                        <span aria-hidden className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full bg-white text-gray-400 ring-1 ring-black/[0.06]">
                            <FileTextIcon size={22} />
                        </span>
                        <p className={cn(TYPE.tt, "m-0 text-gray-900")}>Baseline Snapshot PDF</p>
                        <p className={cn(TYPE.tc, "m-0 mt-1 text-gray-500")}>The PDF Oura makes from the approved results opens here.</p>
                    </div>
                </div>
            )}
        </Drawer>
    );
}
